<template>
   <modal :name="'reassignModalForm'" classes="v-modal-sec"
    :min-width="200"
    :min-height="200"
    :scrollable="true"
    :reset="true"
    width="600px"
    height="auto"
  >
    <div class="v-modal">
      <div class="popup-header fromDetailsPage">
        <h2 class="popup-title">{{popUpTitle}}</h2>
        <span @click="hideMe()">
          <em class="material-icons">close</em>
        </span>
      </div>
      <form data-vv-scope="assignmentForm" class="relative" @submit.prevent @keydown.enter.prevent>
        
       
        <div class="form-container">
          <div class="vx-row" >
            <div class="vx-col w-full" v-if="usersList.length > 0 && ['CASE_APPROVED' ,'SUPERVISOR_FORMS_REVIEW' ,'SUBMIT_TO_USCIS'].indexOf(ACTIVITYCODE)<=-1">
              <div class="form_group">
                <label for class="form_label">User<em>*</em></label>             
                <div class="con-select w-full select-large">
                  <multiselect
                    name="users"
                    v-model="selectedUser"
                    :close-on-select="true"
                    v-validate="'required'"
                    :multiple="false"
                    :show-labels="false"
                    @input="selectUesr"
                    label="tempName"
                    data-vv-as="User"
                    placeholder="Select User"
                    :options="usersList"
                    :searchable="true"
                    :allow-empty="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} selected</span
                      >
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                      ></span>
                    </template>
                  </multiselect>
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('assignmentForm.users')"
                  >{{ errors.first("assignmentForm.users") }}</span
                >
              </div>
            </div>
            <div class="vx-col w-full pad0 mb-3" v-if="enableRedioBtn && ACTIVITYCODE =='RE_ASSIGN' && [51].indexOf(getUserRoleId)<=-1">
              <div class="custom-radio_wrap wf_radio">
                <ul class="custom-radio mb-1" >
                  <li> 
                    <vs-radio @input="addMoreDocs"   name="documentType"  vs-value="misisng_docs" v-model="missingDetails" class="w-full" >Missing Documents</vs-radio>
                  </li>
                  <li>
                    <vs-radio @input="clearMoreDocs"  name="documentType"   vs-value="missing_details"  v-model="missingDetails" class="w-full" >Missing Details</vs-radio>
                  </li>
                </ul>
              </div>
              <!-- <span  class="text-danger text-sm"  v-show="showTypeIdError">Document Type is required</span> -->
            </div>
            <template v-if="missingDetails == 'misisng_docs' && enableRedioBtn && checkProperty(missingDocuments, 'length')>0 && ACTIVITYCODE =='RE_ASSIGN' && [51].indexOf(getUserRoleId)<=-1" >
              <template v-for="(doc, ind) in missingDocuments  ">
                <div class="add_missing_doc">
                  <immiInput :wrapclass="''"  :display="true"   :cid="'docName'+ind" formscope="assignmentForm" 
                  v-model="doc.name" :required="true" 
                  :fieldName="'docName'+ind" :label="'Document Name '+(ind+1)" :placeHolder="'Document Name '+(ind+1)" />
                  <span class="delete_btn" v-if="checkProperty(missingDocuments ,'length')>1" @click="removeDocs(ind)">Delete</span>
                </div>
              </template>
              <span @click="addMoreDocs()" class="add-more ml-4 mb-5" style="min-height:30px;"><span class="pr-2">+</span>Add More</span>
            </template>
            <template v-if="checkProperty(fileUploadMissingDocs, 'length')>0 && ACTIVITYCODE =='BACK_TO_ASSIGN'">
              <div class="vx-col w-full missing_doc_sec">
                <h3 class="small-header pt-0">Missing Documents</h3>
                <casedocumentslist :showTitle="false" @emitUploadingAction="emitUploadingAction" :docMainCategory="'fileUploadMissingDocs'" :docslist="fileUploadMissingDocs"
                formscope="assignmentForm"  v-model="missingDetailsDocs"  :fieldName="''" ></casedocumentslist>
              </div>
            </template>
            
            <label class="missing_doc_details" v-if="reaasignNote && ACTIVITYCODE =='BACK_TO_ASSIGN' && [50,51].indexOf(getUserRoleId)>-1 && assignBackExists">
              <em>Note:</em> <span v-html="reaasignNote"></span>
            </label>
            
            
            <div class="vx-col w-full">
              <div class="form_group mb-4">
                <label class="form_label">Comments<em>*</em></label>
                <ckeditor  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
                  class="w-full mb-5" :editor="editor" :config="editorConfig"></ckeditor>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('assignmentForm.comments')"
                  >Comments are required</span
                >
              </div>
            </div>
            <div class="ml-3 mb-4" v-if="ACTIVITYCODE =='BACK_TO_ASSIGN' && [50,51].indexOf(getUserRoleId)>-1 && assignBackExists">
              <vs-checkbox class="" v-model="confirmationCheck" @input="checkBoxError=''">
                <span>Read the above note and provided all required details</span>
              </vs-checkbox>
              <span
                  class="text-danger text-sm mt-0 ml-2"
                  v-show="checkBoxError" >{{checkBoxError}}</span
                >
            </div>
          </div>
  
          <div class="text-danger text-sm formerrors my-2" v-show="formErrors">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formErrors }}</vs-alert
            >
          </div>
        </div>
  
        <div class="popup-footer relative">
          <span class="loader" v-if="loading || documentUploading"
            ><img src="@/assets/images/main/loader.gif"
          /></span>
          <vs-button
            color="dark"
            @click="showPopup = false"
            class="cancel"
            type="filled"
            >Cancel</vs-button
          >
          
  
          <vs-button
            
            :disabled="loading"
            color="success"
            @click="submitreAssignAction()"
            class="save"
            type="filled"
            >
            <template v-if="ACTIVITYCODE =='BACK_TO_ASSIGN'">Report Back</template>
            <template v-else>Assign</template>
            
          </vs-button>
         
        </div>
      </form>
    </div>
  </modal>
  </template>
 <script>
 import moment from "moment"; 
 import { EyeIcon } from "vue-feather-icons";
 import * as _ from "lodash";
 import Vue from 'vue';
 Vue.use( CKEditor );
 import CKEditor from '@ckeditor/ckeditor5-vue2';
 import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
 import immiInput from "@/views/forms/fields/simpleinput.vue";
 import casedocumentslist from "@/views/common/casedocuments.vue";
 import JQuery from "jquery";
 
 export default {
   provide() {
     return {
       parentValidator: this.$validator,
     };
   },
   methods: {
    checkBoxConfirmation(){
      this.checkBoxError = '';
      let returnVal = true;
      if(this.ACTIVITYCODE =='BACK_TO_ASSIGN' && [50,51].indexOf(this.getUserRoleId)>-1 && this.assignBackExists && this.confirmationCheck == false){
        returnVal = false
        this.checkBoxError = '*Field is required'
      }
      return returnVal;
    },
     addMoreDocs(){
       let tempObj  = {
         name:'',
         documents:[]
       }
       if(this.checkProperty(this.missingDocuments, 'length')>0){
         let findObj = _.find(this.missingDocuments,{'name':''});
         if(!findObj){
           this.missingDocuments.push(tempObj);
         }
         if(findObj){
           this.$validator.validateAll('assignmentForm')
         }
       }else{
         this.missingDocuments.push(tempObj);
         setTimeout(()=>{
           this.$validator.reset();
         })
       }
     },
     removeDocs(index){
       this.missingDocuments.splice(index, 1);
     },
     clearMoreDocs(){
       this.missingDocuments = [];
     },
     emitUploadingAction(data){
       if(_.has(data,'docMainCategory')){
         _.map(this[data['docMainCategory']],(item)=>{
           if(item['fieldName'] == data['fieldName']){
             item = Object.assign( item ,{ "fileUploading": false})
             item['fileUploading'] = data['action'] 
           }
         })
       }
       if(_.has(data,'allFilesAreUploaded')){
                    if(data['allFilesAreUploaded'] && this.checkProperty(data,'uploadFIlesErrors', 'length') >0){
                        let joinedError = '';
                                if(data['uploadFIlesErrors'].length>0){
                                    joinedError = data['uploadFIlesErrors'].join(", ")
                                }
                        this.showToster({
                                        message:joinedError,
                                        isError: true,
                                    });

                    }

                }
       this.checkSubmitBtn(data)
     },
     checkSubmitBtn(data){
       this.documentUploading = false;
       if(_.has(data,'docMainCategory')){
         _.forEach(this[data['docMainCategory']],(item)=>{
           if(_.has(item,'fileUploading') && item['fileUploading']){
             this.documentUploading = true;
             return false;
           }
         })
       }
     },
     assignDocumentList(){
       let documentsArray = [];
       if(this.missingDetailsDocs){
         let catDocuments =Object.entries(this.missingDetailsDocs);
         let self = this;
         let obj={}
         if(self.checkProperty(catDocuments, 'length')>0){
           _.forEach(catDocuments,(item)=>{
             if(item){
               let category =_.cloneDeep(item[0]);
               let findObj = _.find(this.fileUploadMissingDocs,{'key':category});
               let categoryName =  '';
               if(findObj){
                 categoryName = findObj['label']
               }
               let tempDocs = [];
               if(self.checkProperty(item[1], 'length')>0){
                 tempDocs = item[1];
                 _.forEach(tempDocs, (item)=>{
                   if(_.has(item, 'name')){
                     item['name'] = categoryName+'-'+item['name'];
                   }
                 })
               }
               obj['name'] = categoryName;
               obj['documents'] = tempDocs;
               documentsArray.push(obj);
             }
             obj={}
           })
         }
       }
       return documentsArray
     },
     getLcaExecuitiveList(){
       this.selectedSigner =null
       // {{workFlowDetails}}
     
        
       
 
            //let companyIdRoles =[50,51];
            let branchIdRoles =[14];
             let postData ={
               "matcher":{ "roleIds": [14], "branchId":"",},              
               "page": 1,	
               "perpage":100000000,
               
             };
            
               
               
 
             if(this.checkProperty(this.petitionDetails ,'branchId')){
                 postData['matcher']['branchId'] = this.checkProperty(this.petitionDetails ,'branchId');
               }
               
 
             
             this.$store.dispatch("getList",{data:postData ,path:'/petition/assign-user-list'} ).then(response => {
              //alert(JSON.stringify(response.list));
              let lst = []
             
             _.forEach(response.list ,(item)=>{
 
               item['tempName']= item['name'];
           if (
             _.has(item, "name") &&
             _.has(item, "roleName") &&
             item._id != this.getUserData["userId"]
           ) {
             item.tempName = item.name + " (" + item.roleName + ")";
             lst.push(item);
           }
               
             
 
 
             });
             this.usersList = lst;
 
 
             })
 
 
 
         
       
 
     },
     selectUesr(item){
      this.assignBackExists = false;
       this.enableRedioBtn = false;
       if(_.has(item, 'roleId') && [50,51].indexOf(item['roleId'])>-1){
         this.enableRedioBtn = true;
       }
       if(this.enableRedioBtn == false && this.ACTIVITYCODE=='BACK_TO_ASSIGN' && this.usersList && this.usersList.length >1){
         this.missingDetailsDocs={};
         this.fileUploadMissingDocs=[];
         let userId = this.getUserData['userId'];
         let myItems = _.filter(this.petitionDetails['reassignLogs'] ,{"assignedBack":false,'toUserId':userId});
         if(myItems && myItems.length>0){
           let it = _.find(myItems,{"createdBy":item['userId']});
           if(_.has(it, 'comment') && it['comment']){
              this.reaasignNote = it['comment'];
            }
           if(_.has(it, 'reassignType') && it['reassignType'] == 'misisng_docs' && _.has(it, 'reqDocs')
             && this.checkProperty(it, 'reqDocs', 'length')>0 ){
             let tempReqDocs = _.cloneDeep(it['reqDocs']);
             this.assignBackExists = true;
             let temFileObj = {
               required: false,
               fileUploading:false,
               key: '',
               fieldName: '',
               label: ''
             }
             _.forEach(tempReqDocs, (docObj)=>{
               if(_.has(docObj, 'name')){
                 let tempName = docObj['name'].trim();
                 tempName = tempName.replace(/\s+/g, '_');
                 temFileObj['key'] = tempName;
                 temFileObj['fieldName'] = tempName;
                 temFileObj['label'] = docObj['name'];
                 this.fileUploadMissingDocs.push(temFileObj);
                 if(_.has(docObj, 'documents')){
                   this.missingDetailsDocs[tempName] = docObj['documents'];
                 }
               }
               temFileObj = { required: false, fileUploading:false, key: '',  fieldName: '',  label: '' }
             })
           }
           if(_.has(it, 'reassignType') && it['reassignType'] == 'missing_details'){
              this.assignBackExists = true;
            }
         }
       }
     },
     openReAssignToReviewerPopUp(){
       this.selectedUser =null;
       this.comments = '';
       this.loading =false;
       this.assignBackExists = false;
       this.comments ="Case "+this.petitionDetails.typeDetails.name+", "+this.petitionDetails.subTypeDetails.name+" is being re-assigned for corrections/changes/updates."
       if(this.usersList.length==1){
         
         this.selectedUser = _.cloneDeep(this.usersList[0]);
       
       }
       if(this.ACTIVITYCODE !='BACK_TO_ASSIGN'){
       if([50].indexOf(this.getUserRoleId)>-1){
         this.selectedUser = _.find(this.usersList ,{'roleId':51});
         this.selectUesr(this.selectedUser);
         
       }else if([51].indexOf(this.getUserRoleId)>-1){
           this.usersList = _.filter(this.usersList ,{'roleId':50});
         this.selectedUser = _.find(this.usersList ,{'roleId':50});
         this.selectUesr(this.selectedUser);
       }
       }
       if(this.ACTIVITYCODE=='BACK_TO_ASSIGN'){
         this.missingDetailsDocs={};
         this.reaasignNote = '';
         this.fileUploadMissingDocs=[];
         if(_.has(this.petitionDetails, 'reassignLogs')){
           let userId = this.getUserData['userId'];
           let myItems = _.filter(this.petitionDetails['reassignLogs'] ,{"assignedBack":false,'toUserId':userId});
           if(myItems && myItems.length == 1 && this.usersList && this.usersList.length==1){
             let it = myItems[0];
             if(_.has(it, 'comment') && it['comment']){
              this.reaasignNote = it['comment'];
             }
               if(_.has(it, 'reassignType') && it['reassignType'] == 'misisng_docs' && _.has(it, 'reqDocs')
                 && this.checkProperty(it, 'reqDocs', 'length')>0 ){
                 let tempReqDocs = _.cloneDeep(it['reqDocs']);
                 this.assignBackExists = true;
                 let temFileObj = {
                   required: false,
                   fileUploading:false,
                   key: '',
                   fieldName: '',
                   label: ''
                 }
                 _.forEach(tempReqDocs, (docObj)=>{
                   if(_.has(docObj, 'name')){
                     let tempName = docObj['name'].trim();
                     tempName = tempName.replace(/\s+/g, '_');
                     temFileObj['key'] = tempName;
                     temFileObj['fieldName'] = tempName;
                     temFileObj['label'] = docObj['name'];
                     this.fileUploadMissingDocs.push(temFileObj);
                    if(_.has(docObj, 'documents')){
                      this.missingDetailsDocs[tempName] = docObj['documents'];
                    }
                   }
                   temFileObj = { required: false, fileUploading:false, key: '',  fieldName: '',  label: '' }
                 })
               }
               if(_.has(it, 'reassignType') && it['reassignType'] == 'missing_details'){
                this.assignBackExists = true;
               }
           }
         }
       }
       this.$validator.reset();
     },
     submitreAssignAction(){
       this.$validator.validateAll("assignmentForm").then((result) => {
         if(result && this.checkBoxConfirmation()){
           let postData ={
               "petitionId": "",
               "userId": "",
             //   "userName": "",
               //"roleId": '',
               "typeName": "",
               "subTypeName": "",
               "comment": ""
           };
           postData['petitionId'] = this.checkProperty(this.petitionDetails ,'_id'); 
           postData['userId'] = this.checkProperty(this.selectedUser ,"_id"),
           // postData['userName'] = self.checkProperty(self.selectedAssignToReviewer ,'roleName'); 
           // postData['roleId'] = self.checkProperty(self.selectedAssignToReviewer ,'roleId'); 
           postData['typeName'] = this.checkProperty(this.petitionDetails,'typeDetails','name'); 
           postData['subTypeName'] = this.checkProperty(this.petitionDetails,'subTypeDetails','name');
           postData['comment'] = this.comments; 
           if(this.enableRedioBtn && this.ACTIVITYCODE == 'RE_ASSIGN'){
             postData['reassignType'] = this.missingDetails;
             if(this.missingDetails == 'misisng_docs'){
               postData['reqDocs'] = this.missingDocuments;
             }
           }
           if(this.assignBackExists && this.ACTIVITYCODE=='BACK_TO_ASSIGN' && [50,51].indexOf(this.getUserRoleId)>-1 ){
             postData['reassignType'] = this.missingDetails;
             postData['reqDocs'] = this.assignDocumentList();
           }
           this.loading =true;
           let url ="/petition/reassign"; 
           if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1 ){
             url = "/perm/reassign"; 
           }
           this.formErrors ='';
           this.$store.dispatch("commonAction" ,{data:postData,path:url})
           .then(response => {
             this.showPopup =false;
             this.showToster({message:response.message,isError:false });
             this.loading =false;
             this.$emit("updatepetition" ,'');
             this.$emit("hideMe");                
           }).catch((err)=>{
             this.formErrors =err;
             this.loading =false;
           })
         }
       })
     },
     submitForm() {
      
     this.$validator.validateAll("assignmentForm").then((result) => {
       
             if (result && false) {
               let postData = {
                petitionId: this.petitionDetails['_id'],
                 comment: this.comments,
                   "userId": this.checkProperty(this.selectedUser ,"_id"),
                   "userName": this.checkProperty(this.selectedUser ,"name"),
                   "roleId":  this.checkProperty(this.selectedUser ,"roleId"),
                   "assignRoleName":  this.checkProperty(this.selectedUser ,"roleName"),
                   subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
                   typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
                    "action":this.ACTIVITYCODE, //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
                  isSkippedAction:false
 
               };
             let path = "/petition/assign-a-role";
               if(this.ACTIVITYCODE == "SUPERVISOR_FORMS_REVIEW" || this.ACTIVITYCODE == "CASE_APPROVED" || this.ACTIVITYCODE == "SUBMIT_TO_USCIS"){
                 path = "/petition/manage-approval-process";
                  postData = {
                 petitionId: this.petitionDetails['_id'],
                 comment: this.comments,
                 subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
                 typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
                 "action":this.ACTIVITYCODE, //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
                 today: moment().format('YYYY-MM-DD')
               }
 
               }
 
               if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1){
                   path ="/perm/assign-a-role";
                   if(this.ACTIVITYCODE == "CASE_APPROVED" || this.ACTIVITYCODE == "SUBMIT_TO_USCIS"){
                     path = "/perm/manage-approval-process";
                   }
 
                }
               
               
 
     
 
               
               //alert(JSON.stringify(postData))
                this.loading =true;
                this.$store
               .dispatch("commonAction", {"data":postData ,"path":path})
               .then(response => {
                 this.showPopup =false;
                 this.openAtornyPopup =false;
                 this.showToster({message:response.message,isError:false });
                   this.loading =false;
                    this.$emit("updatepetition" ,'');
                    this.$emit("hideMe");
                 
                 
                 
                                 
               })
               .catch((error)=>{
                 
                 this.formErrors =error;
                 this.loading =false;
               })
               
        
        
 
               
             }
           });
     },
     hideMe() {
       this.$emit("hideMe");
       setTimeout(()=>{
         this.$modal.hide('jobDescPopModal');
       })
       
     },
   },
   watch: {
     showPopup(val) {
      const $ = JQuery;
        if (val) {
            $('body').addClass('vm--block-scroll');
        } else {
          $('body').removeClass('vm--block-scroll');
          this.$emit("hideMe");
          this.$modal.hide("reassignModalForm");
        }

      //  if (!val) this.$emit("hideMe");
      //  this.$modal.hide("reassignModalForm");
     },
   },
   beforeDestroy() {
      const $ = JQuery;
      $('body').removeClass('vm--block-scroll')
    },
   mounted() {
     this.showPopup = true;
     this.$modal.show("reassignModalForm");
    
     this.assignBackExists = false;
     let self = this;
     this.caseUsers = [];
    //  const $ = JQuery;
    //  $('body').addClass('vm--block-scroll')
     let postData = {
       petitionId: self.petitionDetails['_id'],
       page: 1,
       perpage: 2500,
     };
     let url ="/petition/assigned-user-list"; 
     if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1){
       url = "/perm/assigned-user-list"; 
     }
     this.$store
     .dispatch("getList", {
       data: postData,
       path:url,
     })
     .then((response) => {
       if (self.checkProperty(response, "list")) {
         let list = [];
         let responseList = response["list"];
         let notAllowUserRolles =[]
         if([3,4,5,6,7,8,9,10,11,12,13,14].indexOf(this.getUserRoleId)>-1 && this.getTenantTypeId !=2){

          if([3,4].indexOf(this.checkProperty(this.petitionDetails, 'typeDetails', 'id'))>-1 && [17, 19].indexOf(this.checkProperty(this.petitionDetails, 'subTypeDetails', 'id'))>-1 ){
            notAllowUserRolles =[]
          }else{
            notAllowUserRolles =[51]
          }
         }else if([50].indexOf(this.getUserRoleId) >-1){
           notAllowUserRolles =[];
         }else if([51].indexOf(this.getUserRoleId) >-1 && this.getTenantTypeId !=2){
           notAllowUserRolles =[3,4,5,6,7,8,9,10,11,12,13,14]
         }

       
         if(notAllowUserRolles.length>0){
         responseList = _.filter(responseList ,( item)=>{
           return notAllowUserRolles.indexOf(item.roleId)<=-1

         })

         }

         if([14].indexOf(this.getUserRoleId) >-1 && this.workFlowDetails && _.has(this.workFlowDetails ,'config')){

         
         let lcaRequired = _.find(this.workFlowDetails.config , {"code":'LCA_REQUEST'});
         let lcaSubmit = _.find(this.workFlowDetails.config , {"code":'LCA_SUBMIT'});
         
         if(lcaRequired['actionRequired'] =="Yes" &&  (lcaRequired && lcaRequired.editors) || (lcaSubmit && lcaSubmit['editors']) ){
             let lcaRequestEditors = _.filter(lcaRequired["editors"] ,(ed)=>{
                                       return ed['roleId'] !=50
                                     })
         let reqEditors = _.map(lcaRequestEditors, 'roleId');

         let lcaSubmitEditors = _.filter(lcaSubmit["editors"] ,(ed)=>{
             return ed['roleId'] !=50
         })
         let lcaSubmitAllEditors = _.map(lcaSubmitEditors, 'roleId');

         
         responseList = _.filter(responseList ,( item)=>{
           return reqEditors.indexOf(item.roleId)>-1 || lcaSubmitAllEditors.indexOf(item.roleId)>-1

           })
     
           
         }
       }
         _.forEach(responseList, (user) => {
           user['tempName']= user['name'];
           if (_.has(user, "roleName")) {
               user["tempName"] =
               user["name"] + " (" + user["roleName"] + ")";
           }
           if(this.ACTIVITYCODE=='BACK_TO_ASSIGN'){
             if(_.has(this.petitionDetails, 'reassignLogs')){
               let userId = this.getUserData['userId'];
               let myItems = _.filter(this.petitionDetails['reassignLogs'] ,{"assignedBack":false,"createdBy":user['userId']  ,'toUserId':userId});
               if(myItems && myItems.length>0){
                 list.push(user);
               }
             }
           }else{
             list.push(user);
           }
         });
         self.usersList = list;

         
       }
       self.openReAssignToReviewerPopUp();
     }).catch((err)=>{
       self.openReAssignToReviewerPopUp();
     }) 
     if(this.ACTIVITYCODE=='RE_ASSIGN'){
      this.missingDocuments = [];
     }
   },
   data: () => ({
    checkBoxError:'',
    reaasignNote:'',
    confirmationCheck:false,
     assignBackExists:false,
     documentUploading:false,
     missingDetailsDocs:{},
     fileUploadMissingDocs:[],
     missingDocuments:[],
     missingDetails:'',
     enableRedioBtn:null,
     editor: ClassicEditor,
     editorConfig: {
       toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
     },
     usersListReviewrsRolesList:[],
     loading:false,
     comments:null,
     usersList: [],
     showPopup: false,
     settingCaseNumber: false,
     selectedUser:null,
     formErrors: null,
   }),
   props: {
     ACTIVITYCODE: {
       type: String,
       default: null,
     },
     rolesList: [],
     popUpTitle: {
       type: String,
       default: null,
     },
     petitionDetails: {
       type: Object,
       default: null,
     },
     workFlowDetails: {
     type: Object,
     default: null,
   },
   },
   components:{
     EyeIcon,
     immiInput,
     casedocumentslist
   },
   computed:{
    
   }
 };
 </script>
  